import { useRef, useEffect } from "react";

import { type ActionCreatorWithPayload } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";

interface InitializeDataProps<T> {
  action: ActionCreatorWithPayload<T>;
  data: T;
}

const useInitializeDataToStore = <T>({ action, data }: InitializeDataProps<T>): void => {
  const dispatch = useDispatch();
  const initialized = useRef(false);

  useEffect(() => {
    if (!initialized.current && action && data !== undefined) {
      try {
        // Ensure we're on the client side
        if (typeof window !== 'undefined') {
          const actionResult = action(data);
          if (actionResult && typeof actionResult === 'object' && 'type' in actionResult) {
            dispatch(actionResult);
            initialized.current = true;
          } else {
            console.error('Invalid action result:', actionResult);
          }
        }
      } catch (error) {
        console.error('Error dispatching action:', error);
      }
    }
  }, [action, data, dispatch]);
};

export default useInitializeDataToStore;
